<template>
  <modal-wrapper :shown="createGroupModalShown" @hide="hideCreateGroupModal">
    <div class="px-4">
      <div class="text-lg font-bold">Add new group</div>
      <div class="flex flex-col mt-6 space-y-4">
        <div>
          <field-label for="groupName">Name</field-label>
          <input-field type="text" id="groupName" v-model="newGroup.name" />
        </div>
      </div>
      <action-button class="mt-6" @click="checkAndAddGroup">
        Add
      </action-button>
      <action-button class="mt-3" type="outline" @click="hideCreateGroupModal">
        Cancel
      </action-button>
    </div>
  </modal-wrapper>
</template>

<script>
import { call, get, sync } from "vuex-pathify";

import ModalWrapper from "@/components/ModalWrapper";
import FieldLabel from "@/components/inputs/FieldLabel";
import InputField from "@/components/inputs/InputField";
import ActionButton from "@/components/inputs/ActionButton";

export default {
  components: {
    ModalWrapper,
    FieldLabel,
    InputField,
    ActionButton,
  },
  data() {
    return {
      newGroup: {
        name: "",
      },
    };
  },
  computed: {
    favorites: get("favorites"),
    selectedFavoritesGroupIndex: sync("selectedFavoritesGroupIndex"),
    createGroupModalShown: sync("createGroupModalShown"),
  },
  methods: {
    checkAndAddGroup() {
      if (this.newGroup.name === "") {
        console.log("Please give your group a name");
      } else {
        this.addGroup(this.newGroup);
        this.hideCreateGroupModal();
        this.selectedFavoritesGroupIndex = this.favorites.length - 1;
      }
    },
    addGroup: call("addGroup"),
    hideCreateGroupModal() {
      this.createGroupModalShown = false;
    },
  },
};
</script>